import * as Sentry from '@sentry/react'

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE
  const release = import.meta.env.VITE_SENTRY_RELEASE

  if (!dsn) {
    console.warn('Sentry DSN not configured. Error tracking is disabled.')
    return
  }

  Sentry.init({
    dsn,
    environment,
    release,
    
    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Session Replay
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    // Capture unhandled promise rejections
    attachStacktrace: true,

    // Filter out certain errors
    beforeSend(event, hint) {
      const error = hint.originalException

      // Filter out network errors that are user-initiated (e.g., cancelled requests)
      if (error && typeof error === 'object' && 'message' in error) {
        const message = String(error.message).toLowerCase()
        if (message.includes('cancel') || message.includes('abort')) {
          return null
        }
      }

      return event
    },

    // Don't send errors in development by default
    enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLED === 'true',
  })
}
